import styled from 'styled-components'
// themes
import colors from 'themes/colors'
// utils
import { darken } from 'polished'

const FieldLabel = styled.span`
  margin-left: 8px;
`

const AddFieldButtonWrapper = styled.div`
  color: ${colors.blue500};
  display: inline-flex;
  align-items: center;
  padding: 16px 0;
  cursor: pointer;
  border-radius: 4px;

  &:hover {
    color: ${darken(0.1, colors.blue500)};

    svg {
      path {
        fill: ${darken(0.1, colors.blue500)};
      }
    }
  }

  & > span {
    margin-left: 8px;
    white-space: nowrap;
  }
`

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  width: 100%;

  > svg:last-child {
    margin-left: auto;
  }
`

export { FieldLabel, AddFieldButtonWrapper, Wrapper }
